export default "__VITE_PUBLIC_ASSET__90a06d51__"